
import { useSearchParams } from 'react-router-dom';
import { useEffect, useState, FormEvent } from 'react';
import './style/login.css';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import { useNavigate } from 'react-router-dom';

import { resetPassword } from '../../actions/UserManagement';


const ResetPassword = () => {

  const [searchParams] = useSearchParams();
  const [token, setToken] = useState('');
  const [email, setEmail] = useState('');
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  useEffect(() => {
    const tokenParam = searchParams.get('token');
    const emailParam = searchParams.get('email');

    document.title = 'Reset Password | Vinimark | The Wine Company';

    if (tokenParam && emailParam) {
      setToken(tokenParam);
    //   setEmail(emailParam);
    }
  }, [searchParams]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    try {
      const response = await resetPassword(email, password, confirmPassword, token);

      if (response.status === 200) {
        navigate('/login')
      }
    } catch (error: any) {
      // Handle error (e.g., show validation errors or error message)
      console.error('Password reset failed:', error.response?.data || error.message);
    }
  };

  return (
    <div style={{ width: '100vw' }}>
      <Header />
      <div className="forgot-password-container">
  <div className="forgot-password-inner">
          <div className="site-grid" style={{ width: '100%' }}>
            <div className="item item-double-content">
              <div className="item-inner"></div>
              <div className="item-inner item-inner-content">
                <div className="content">
                  <div className="content-title">
                    <h2 className="content-title-small">Reset Password</h2>
                  </div>
                  <div className="content-text">
                    <p className='content-text'>Reset your password</p>
                  </div>

                  <form className="content-form" onSubmit={handleSubmit}>
                  <div className="content-form-field">
                      <input
                        type="text"
                        className="input-email"
                        placeholder="Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div className="content-form-field">
                      <input
                        type="password"
                        className="input-email"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                    <div className="content-form-field">
                      <input
                        type="password"
                        className="input-email"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                    </div>

                    <div className="content-form-button">
                      <button type="submit" className="button button-wide">Reset Password</button>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ResetPassword;
